<mat-card>
  <h2>Versionshistorie: {{ documentTitle }}</h2>
  <mat-card-content>
    <p *ngIf="loading" class="loading">
      <mat-spinner diameter="32"></mat-spinner>
      Versionen werden geladen…
    </p>
    <p *ngIf="error" class="error">{{ error }}</p>

    <div *ngIf="!loading && !error" class="version-list">
      <table mat-table [dataSource]="versions" class="mat-elevation-z0">
        <ng-container matColumnDef="validFrom">
          <th mat-header-cell *matHeaderCellDef>
            <span class="header-with-filter">
              <span class="header-label">Gültig ab: </span>
              <span ><input type="date" class="date-filter" [(ngModel)]="VersionsValidFrom" (change)="loadDocumentAndVersions()" /></span>
            </span>
          </th>
          <td mat-cell *matCellDef="let v">{{ v.createdAt | date: 'dd.MM.yyyy, HH:mm' }}</td>
        </ng-container>
        <ng-container matColumnDef="createdByUserId">
          <th mat-header-cell *matHeaderCellDef>Benutzer (ID)</th>
          <td mat-cell *matCellDef="let v">{{ v.createdByUserId }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let v">
            <button mat-raised-button color="primary" (click)="viewVersion(v.id)">Anzeigen</button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <p *ngIf="versions.length === 0" class="no-data">Keine Versionen vorhanden.</p>
    </div>
    <div class="actions">
      <button mat-raised-button (click)="back()">Zurück zur Übersicht</button>
    </div>
  </mat-card-content>
</mat-card>
